import React, { useEffect, useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import Products from "./Products";
import MarketsContent from "./MarketsContent";
import IpoContent from "./IpoContent";
import ToolsContent from "./ToolsContent";
import EssentialReports from "./EssentialReports";
import TransactContent from "./TransactContent";
import { ILoginFlows } from "@domains/features/LoginFlow/entities/CommonLoginData";
import { useSelector } from "react-redux";
import _ from "underscore";
const NavMenu = (props) => {
    const [index, setIndex] = useState(0);
    const wrapperRef = React.useRef(null);
    const [showNav, setShowNav] = useState(false);
    const [userType, setUserType] = useState();
    const [userID, setUserID] = useState();
    const userId = useSelector((state) => state.accountDetailsReducer.userID, _.isEqual);
    const guestUserID = useSelector((state) => state.LoginFlow.guestValidateMPIN.data.guestId, _.isEqual);
    let checkUserData = async () => {
        if (!!userId) {
            setUserType(ILoginFlows.CLIENT);
            setUserID(userId);
        }
        if (!!guestUserID) {
            setUserType(ILoginFlows.GUEST);
            setUserID(guestUserID);
        }
    };
    useEffect(() => {
        checkUserData();
    }, [userId, guestUserID]);
    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShowNav(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [wrapperRef]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "nav-menu", ref: wrapperRef },
            React.createElement("div", { className: "nav-tabs brdbottom" },
                React.createElement(Tabs, { selectedIndex: index, onSelect: (index) => {
                        setIndex(index);
                    }, defaultIndex: index, selectedTabClassName: showNav ? "current" : "", selectedTabPanelClassName: showNav ? "current" : "", onMouseLeave: (e) => {
                        setIndex(index);
                    } },
                    React.createElement(TabList, { className: "tabs" },
                        React.createElement(Tab, { className: "tab-link  displayFlex", onClick: (e) => {
                                setIndex(0);
                                if (index === 0)
                                    setShowNav(!showNav);
                                else
                                    setShowNav(true);
                            } },
                            React.createElement("div", null,
                                React.createElement("span", { className: "nav-menu-outer" },
                                    React.createElement("span", { className: "nav-head" }, "Products"),
                                    React.createElement("span", { className: showNav && index == 0
                                            ? "edel-icon-arrow-down down"
                                            : "edel-icon-arrow-down " })))),
                        React.createElement(Tab, { className: "tab-link  displayFlex", onClick: (e) => {
                                setIndex(1);
                                if (index === 1)
                                    setShowNav(!showNav);
                                else
                                    setShowNav(true);
                            } },
                            React.createElement("div", null,
                                React.createElement("span", { className: "nav-menu-outer" },
                                    React.createElement("span", { className: "nav-head" }, "Markets"),
                                    React.createElement("span", { className: showNav && index == 1
                                            ? "edel-icon-arrow-down down"
                                            : "edel-icon-arrow-down " })))),
                        React.createElement(Tab, { className: "tab-link  displayFlex", onClick: (e) => {
                                setIndex(2);
                                if (index === 2)
                                    setShowNav(!showNav);
                                else
                                    setShowNav(true);
                            } },
                            React.createElement("div", null,
                                React.createElement("span", { className: "nav-menu-outer" },
                                    React.createElement("span", { className: "nav-head" }, "IPO"),
                                    React.createElement("span", { className: showNav && index == 2
                                            ? "edel-icon-arrow-down down"
                                            : "edel-icon-arrow-down " })))),
                        React.createElement(Tab, { className: "tab-link  displayFlex", onClick: (e) => {
                                setIndex(3);
                                if (index === 3)
                                    setShowNav(!showNav);
                                else
                                    setShowNav(true);
                            } },
                            React.createElement("div", null,
                                React.createElement("span", { className: "nav-menu-outer" },
                                    React.createElement("span", { className: "nav-head" }, "Tools"),
                                    React.createElement("span", { className: showNav && index == 3
                                            ? "edel-icon-arrow-down down"
                                            : "edel-icon-arrow-down " })))),
                        React.createElement(Tab, { className: "", onClick: (e) => {
                                setIndex(4);
                                if (index === 4)
                                    setShowNav(!showNav);
                                else
                                    setShowNav(true);
                            } },
                            React.createElement("div", null,
                                React.createElement("span", { className: "nav-menu-outer" },
                                    React.createElement("span", { className: "nav-head" }, "Reports"),
                                    React.createElement("span", { className: showNav && index == 4
                                            ? "edel-icon-arrow-down down"
                                            : "edel-icon-arrow-down " })))),
                        userID ? (React.createElement(React.Fragment, null,
                            React.createElement(Tab, { className: "", onClick: (e) => {
                                    setIndex(5);
                                    if (index === 5)
                                        setShowNav(!showNav);
                                    else
                                        setShowNav(true);
                                } },
                                React.createElement("div", null,
                                    React.createElement("span", { className: "nav-menu-outer" },
                                        React.createElement("span", { className: "nav-head" }, "Transact"),
                                        React.createElement("span", { className: showNav && index == 5
                                                ? "edel-icon-arrow-down down"
                                                : "edel-icon-arrow-down " })))))) : ("")),
                    React.createElement("div", { 
                        //  ref={wrapperRef}
                        className: (showNav && index == 2) ||
                            (showNav && index == 3) ||
                            (showNav && index == 5)
                            ? `tabContentsWrap ${"auto-width-" + index}`
                            : "tabContentsWrap" },
                        React.createElement(TabPanel, { className: ["tab-content"] },
                            React.createElement(Products, { setShowNav: setShowNav, showNav: showNav })),
                        React.createElement(TabPanel, { className: "tab-content" },
                            React.createElement(MarketsContent, { setShowNav: setShowNav, showNav: showNav })),
                        React.createElement(TabPanel, { className: "tab-content" },
                            React.createElement(IpoContent, { setShowNav: setShowNav, showNav: showNav })),
                        React.createElement(TabPanel, { className: "tab-content" },
                            React.createElement(ToolsContent, { setShowNav: setShowNav, showNav: showNav })),
                        React.createElement(TabPanel, { className: "tab-content essential-tab" },
                            React.createElement(EssentialReports, { setShowNav: setShowNav, showNav: showNav, setMoreReport: props.setMoreReport })),
                        userID ? (React.createElement(React.Fragment, null,
                            React.createElement(TabPanel, { className: "tab-content transact-tab" },
                                React.createElement(TransactContent, { setShowNav: setShowNav, showNav: showNav })))) : ("")))))));
};
export default NavMenu;
